'use client'

import { useViewer } from '@/features/viewer/hooks/use-viewer'

import { fitsVehicle } from '../lib/product-rules'

export default function FitsBadge({ vehicleIds }: { vehicleIds: string[] }) {
  const { viewer } = useViewer()
  if (!fitsVehicle({ vehicleIds }, viewer?.vehicle?.id ?? null)) return null
  return <span className="text-success">내 차 호환</span>
}
